module.exports = __webpack_public_path__ + "img/scene1copysub.e369a2d0.png";